import { useFetcher, useLoaderData } from "react-router-dom";
import { buildPublicPdfLink } from "../../utils/buildPublicPdfLink";
import { doFetch } from "../../utils/doFetch";
import { VesselForecast } from "./VesselForecast";
import { AllocationType, ISLANDPORTS, LOCATIONS, Locations, MAINLANDPORTS } from "./VesselForecastModels";

export const VesselForecastRouteLoader = async ({ request, params }: { request: any, params: any }) => {
  // set parameters
  const allocationType = params.allocationType ?? AllocationType.daily;
  const selectedLocation = params.location ?? LOCATIONS[0].code;
  const selectedPort = params.port ?? MAINLANDPORTS[0].code;
  let shiftHeaders = null;
  let data = null;
  if (allocationType === AllocationType.daily) {
    data = await doFetch(
      `vessel-forecast/${allocationType}/${selectedPort}`, { signal: request.signal }, true, false
    );

    return {
      dailyAllocations: {
        selectedLocation,
        selectedPort,
        shiftHeaders,
        ...data,
      },
      weeklyAllocations: {
        selectedLocation,
        selectedPort,
        shiftHeaders,
      }
    };
  } else {
    shiftHeaders = ["01:00", "08:00", "16:30"];

    data = await doFetch(
      `vessel-forecast/${allocationType}/${selectedPort}`, { signal: request.signal }, true, false
    );

    return {
      dailyAllocations: {
        selectedLocation,
        selectedPort,
        shiftHeaders,
      },
      weeklyAllocations: {
        selectedLocation,
        selectedPort,
        shiftHeaders,
        ...data,
      }
    };
  }
}

export const VesselForecastRoute = () => {
  const fetcher = useFetcher();
  const loaderData = useLoaderData();
  const data = fetcher.data ?? loaderData;

  const handleTabSelect = (newValue: number) => {
    const allocationType = newValue === 0 ? AllocationType.daily : AllocationType.weekly;
    fetcher.load(`/vessel-forecast/${allocationType}`);
  };

  const handleLocationSelect = (
    allocationType: AllocationType,
    selectedLocation: string,
  ) => {
    const [selectedPort] = Locations[selectedLocation as keyof typeof Locations] === Locations.mainland ?
      MAINLANDPORTS : ISLANDPORTS;

    fetcher.load(`/vessel-forecast/${allocationType}/${selectedLocation}/${selectedPort.code}`);
  }

  const handlePortSelect = (
    allocationType: AllocationType,
    selectedLocation: string,
    selectedPort: string,
  ) => {
    fetcher.load(`/vessel-forecast/${allocationType}/${selectedLocation}/${selectedPort}`);
  }

  return (
    <VesselForecast
      data={data}
      handleTabSelect={handleTabSelect}
      handleLocationSelect={handleLocationSelect}
      handlePortSelect={handlePortSelect}
      weeklyAllocationsIslandLink={buildPublicPdfLink("/reports/public/WeeklyAllocationIsland")}
      weeklyAllocationsMainlandLink={buildPublicPdfLink("/reports/public/WeeklyAllocationMainland")}
    />
  )
}